import { useEffect, useState } from "react";
import { _ErrorDetails, _QualityMeasurementInspectionsItems, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import usePaginator from "../../../../theme/Component/usePaginator";


interface Props {
    idQualityMeasurementInspection: number;
}

export const QualityMeasurementInspectionsItems = ({ idQualityMeasurementInspection }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityMeasurementInspectionsItems);
    const paginador = usePaginator()

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (idQualityMeasurementInspection) {
            getLista();
        }
    }, [idQualityMeasurementInspection, paginador.page])

    const getLista = () => {
        const props = {
            State: 1,
            IDQualityMeasurementInspections: idQualityMeasurementInspection
        }
        instance.getQualityMeasurementInspectionsItemsRender(paginador.page, 15, props).then((resp: any) => {
            resp.List.forEach(element => {
                const data = element.DataBeanProperties;

                data.ToleranceValue = data.Tolerance ?? "N/A"
            });

            setLista(resp.List);
            paginador.setPages(resp.NumberOfPages);
            paginador.setRecords(resp.NumberOfPages * (15));
        }).catch(err => {
            toast.error("Error al cargar la lista de Tolerancias");
        });
    };

    const create = () => {
        setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDQualityMeasurementInspections: idQualityMeasurementInspection
        });
        setModal({ ...modal, "name": `Agregar Tolerancia`, "view": true });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateQualityMeasurementInspectionsItems(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDQualityMeasurementInspectionsItems', visible: true },
        { title: 'Talla', property: 'ConstantName', visible: true },
        { title: 'Medida de Norma', property: 'DefaultValue', visible: true },
        { title: 'Tipo de Dato', property: 'TypeName', visible: true },
        { title: 'Tolerancia', property: 'ToleranceValue', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDSize", "DefaultValue", "IDTypeTolerance"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    listButtons={listaBotones()}
                    iconButtons={iconButtonsItem}
                    next={paginador.next}
                    pageTop={paginador.page}
                    back={paginador.back}
                    records={paginador}
                />

                <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('IDSize') ? 'has-error' : ''}`} >Talla</label>
                            <SelectTHConstantsValue label=" " code={913} onChange={(e) => { setBean({ ...bean, IDSize: e }) }} value={bean.IDSize} />
                        </div>

                        <div className="col-md-12">
                            <label className={`${missingFields.includes('DefaultValue') ? 'has-error' : ''}`} >Medida de Norma</label>
                            <input type="number" className="form-control" value={bean.DefaultValue} onChange={(e) => {
                                const value = e.target.value ? Number(e.target.value) : null;
                                setBean({ ...bean, DefaultValue: value })
                            }} />
                        </div>

                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Tolerance') ? 'has-error' : ''}`} >Tipo de Dato</label>
                            <select value={bean.IDTypeTolerance} onChange={(e) => {
                                const valor = e.target.value ? Number(e.target.value) : null;
                                setBean({ ...bean, IDTypeTolerance: valor })
                            }} className="form-select">
                                <option value="">...</option>
                                <option value="100">Minimo</option>
                                <option value="101">Maximo</option>
                                <option value="102">Tolerancia (+/-)</option>
                            </select>
                        </div>

                        {bean.IDTypeTolerance === 102 &&
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Tolerance') ? 'has-error' : ''}`} >Tolerancia</label>
                                <input type="number" className="form-control" value={bean.Tolerance} onChange={(e) => {
                                    const value = e.target.value ? Number(e.target.value) : null;
                                    setBean({ ...bean, Tolerance: value })
                                }} />
                            </div>
                        }
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.TechnicianName}</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}